import { useState, useEffect, type PropsWithChildren } from 'react';

import {
  rememberScrollPosition,
  resetScrollPosition,
} from '../01-core/Utilities';
import { SidepanelContext } from './SidepanelContext';

export const SidepanelProvider = ({ children }: PropsWithChildren) => {
  const [open, setOpen] = useState<string | null>(null);

  const doOpen = (id: string) => {
    const body = document?.body;
    if (!open && body) {
      rememberScrollPosition();
    }
    setOpen(id);
  };

  const doClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    const body = document.body;
    if (open) {
      body.classList.add('sidepanel-open');
    } else {
      body.classList.remove('sidepanel-open');
      resetScrollPosition();
    }
    return () => {
      if (open) {
        const body = document.body;
        body.classList.remove('sidepanel-open');
        resetScrollPosition();
      }
    };
  }, [open]);

  return (
    <SidepanelContext.Provider value={[open, doOpen, doClose]}>
      {children}
    </SidepanelContext.Provider>
  );
};
